import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValue,
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { Tierbemerkung } from '../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tierbemerkung';
import {
    GruppeTierbemerkung,
    KundenBemerkung,
} from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe-tierbemerkung';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-gruppe-bemerkungen-verwalten-dialog',
    templateUrl: './gruppe-bemerkungen-verwalten-dialog.component.html',
    styleUrls: ['./gruppe-bemerkungen-verwalten-dialog.component.scss'],
})
export class GruppeBemerkungenVerwaltenDialogComponent implements OnInit {
    isSaving: boolean;
    gruppenBemerkungen: GruppeTierbemerkung[] = [];
    kundeBemerkungen: KundenBemerkung[] = [];
    subKundeBemerkung: Subscription = new Subscription();
    subGruppenBemerkung: Subscription = new Subscription();
    public showHistory: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<GruppeBemerkungenVerwaltenDialogComponent>,
        private dialog: MatDialog,
        public localStorageService: LocalStorageService,
        @Inject(MAT_DIALOG_DATA) public currentClient: Client,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private backendApi: KieneTableService,
        private messageService: MessageService,
    ) {
        if (this.localStorageService.currentUserHasPermission(9191)) {
            this.loadGruppeTierBemerkungen(false);
        }
        if (this.localStorageService.currentUserHasPermission(3931)) {
            this.loadKundeBemerkungen(false);
        }
    }

    ngOnInit(): void {}

    loadGruppeTierBemerkungen(historieAnzeigen: boolean): void {
        let params = new HttpParams();
        if (!historieAnzeigen) {
            params = params.set('tierarzt', '0');
        }
        if (this.currentClient) {
            if (this.currentClient.unternehmensgruppe_id) {
                params = params.set('unternehmensgruppe_id', this.currentClient.unternehmensgruppe_id);
            } else {
                params = params.set('kunde_id', this.currentClient.kunde_id);
            }
            this.subGruppenBemerkung?.unsubscribe();
            this.subGruppenBemerkung = this.backendApi
                .get(this.apiBaseUrl + 'gruppe_tier_bemerkung/read_grouped.php', params)
                .subscribe({
                    next: (response: any) => {
                        this.gruppenBemerkungen = response;
                    },
                });
        }
    }

    updateGruppenBemerkungRow(event: MouseEvent, bemerkung: Tierbemerkung) {
        event.stopPropagation();
        event.preventDefault();
        this.updateGruppenBemerkung(null, bemerkung);
    }

    isTierarztChecked(tierarzt: number | string): boolean {
        return Number(tierarzt) === 1;
    }

    updateGruppenBemerkung(event: MatCheckboxChange, bemerkung: Tierbemerkung) {
        if (event) {
            bemerkung.tierarzt = event.checked ? 1 : 0;
        } else {
            bemerkung.tierarzt = this.isTierarztChecked(bemerkung.tierarzt) ? 0 : 1;
        }
        this.backendApi
            .updateGeneric(this.apiBaseUrl + 'gruppe_tier_bemerkung/update_kundenportal.php', bemerkung)
            .subscribe({
                next: resp => {
                    this.messageService.infoMessage('Bemerkung erfolgreich aktualisiert!');
                    bemerkung = resp;
                },
                error: err => this.messageService.errorMessage('Fehler beim Aktualisieren der Bemerkung!', err),
            });
    }

    public createKundenBemerkung(bemerkung?: KundenBemerkung): void {
        const isCreate: boolean = !bemerkung;
        if (!bemerkung) {
            bemerkung = new KundenBemerkung();
            bemerkung.kunde_id = this.currentClient.kunde_id;
            bemerkung.tierarzt = 0;
        }
        const input = new EnterValueInput();
        input.title = 'Kundenbemerkung';
        input.text = 'Bitte geben Sie die Bemerkung ein.';
        input.okButton = 'Speichern';
        input.buttonColor = 'accent';

        const enterValue = new EnterValue();
        enterValue.type = 'textarea';
        enterValue.label = 'Bemerkung';
        enterValue.inputmode = 'textarea';
        enterValue.rows = 5;
        if (bemerkung?.bemerkung) {
            enterValue.value = bemerkung.bemerkung;
        }
        input.values.push(enterValue);

        this.dialog
            .open(EnterValueDialogComponent, { data: input, minWidth: '650px' })
            .afterClosed()
            .subscribe({
                next: (res: EnterValueResponse) => {
                    if (res.result) {
                        bemerkung.bemerkung = res.getValue(0);
                        if (bemerkung.bemerkung) {
                            this.updateKundenBemerkung(bemerkung, isCreate);
                        } else {
                            this.messageService.alertMessage('Bitte eine gültige Bemerkung eintragen!');
                        }
                    }
                },
            });
    }

    public markAsRead(bemerkung: KundenBemerkung): void {
        bemerkung.tierarzt = this.isTierarztChecked(bemerkung.tierarzt) ? 0 : 1;
        this.updateKundenBemerkung(bemerkung);
    }

    private loadKundeBemerkungen(historieAnzeigen: boolean): void {
        let params = new HttpParams();
        if (!historieAnzeigen) {
            params = params.set('tierarzt', '0');
        }

        if (this.currentClient) {
            if (this.currentClient.unternehmensgruppe_id) {
                params = params.set('unternehmensgruppe_id', this.currentClient.unternehmensgruppe_id);
            } else {
                params = params.set('kunde_id', this.currentClient.kunde_id);
            }
            this.subKundeBemerkung?.unsubscribe();
            this.subKundeBemerkung = this.backendApi
                .get(this.apiBaseUrl + 'kunde_bemerkung/read.php', params)
                .subscribe({
                    next: (response: any) => {
                        this.kundeBemerkungen = response.records;
                    },
                });
        }
    }

    private updateKundenBemerkung(bemerkung: KundenBemerkung, isCreate?: boolean): void {
        this.backendApi.updateEntity(this.apiBaseUrl + 'kunde_bemerkung/update.php', bemerkung).subscribe({
            next: (response: any) => {
                if (isCreate) {
                    this.kundeBemerkungen.push(response);
                    this.messageService.infoMessage('Bemerkung erfolgreich erstellt!');
                } else {
                    bemerkung = response;
                    this.messageService.infoMessage('Bemerkung erfolgreich aktualisiert!');
                }
            },
            error: err => this.messageService.errorMessage('Fehler beim Erstellen der Bemerkung!', err),
        });
    }

    public toggleShowHistory(): void {
        this.showHistory = !this.showHistory;

        if (this.localStorageService.currentUserHasPermission(9191)) {
            this.loadGruppeTierBemerkungen(this.showHistory);
        }
        if (this.localStorageService.currentUserHasPermission(3931)) {
            this.loadKundeBemerkungen(this.showHistory);
        }
    }
}
